import styled from 'styled-components'
import { HappySquirrel } from 'Icons'
import PoweredBySked from './Common/PoweredBySked'

const Wrap = styled.div`
  display: grid;
  place-items: center;
  margin: 70px auto 120px auto;

  @media (max-width: 767px) {
    margin: 14px auto;
  }

  > svg {
    margin-top: 40px;
    margin-bottom: 112px;
    width: 214px;

    @media (max-width: 767px) {
      margin-top: 60px;
      margin-bottom: 65px;
    }
  }
`

const Message = styled.div`
  text-align: center;
  background: #f0f8e7;
  border-radius: 10px;
  padding: 20px 30px;
  max-width: 360px;
  h2 {
    font-size: 32px;
    font-weight: 500;
  }
  span {
    font-size: 14px;
  }
`

const EmptyUpcomingPosts: React.FC = () => {
  return (
    <Wrap>
      <Message>
        <h2>Time to zen out!</h2>
        <span>No upcoming posts or posts awaiting approval.</span>
      </Message>
      <HappySquirrel data-testid="squirrel_logo" />
      <PoweredBySked />
    </Wrap>
  )
}

export default EmptyUpcomingPosts
